import React, { createContext, useContext } from 'react';

const VisibilityRefreshContext = createContext(null);

export const VisibilityRefreshProvider = ({ value, children }) => {
  return <VisibilityRefreshContext.Provider value={value}>{children}</VisibilityRefreshContext.Provider>;
};

export const useVisibilityRefresh = () => {
  return useContext(VisibilityRefreshContext);
};
